import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { Fragment, useEffect, useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { MdOutlineMeetingRoom } from "react-icons/md";

import EventSlider from "./EventSlider";
import Events from "./assets/Events.svg";
import Sports from "./assets/Sports.svg";
import Hotels from "./assets/Hotels.svg";
import pages from "../../constants/pages";
import useAxios from "./../../hooks/useAxios";
import Corporate from "./assets/Corporate Events.svg";
import Meeting from "./assets/meeting.png";

const OuterBox = styled(Box)`
  display: flex;
  justify-content: center;
  background: linear-gradient(to right, #f7fbfc, rgb(255, 255, 255));
  min-height: 100vh;
`;

const OuterPaper = styled(Paper)`
  width: 100%;
  max-width: 1200px;
  background: #ffffff;
  @media (min-width: 950px) {
    width: 50%;
  }
`;

const CategoryItem = styled(Grid)`
  width: 150px;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  text-align: center;
  // border: 2px solid #e0f2f8;
  border-radius: 12px;
  transition: all 0.1s ease;
  background: white;
  padding: 0px 15px;
  box-shadow: 0px 2px 3px 1px #00000014;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  }

  @media screen and (max-width: 768px) {
    width: 150px;
    height: 80px;
  }

  @media screen and (max-width: 480px) {
    width: 45%;
    height: 67px;
  }
`;

const CategoryGrid = styled(Grid)`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-top: 25px;
`;

const CategoryIcon = styled("img")(({ color }) => ({
  fontSize: "35px",
  width: "35px",
  color: color || "#0073e6",
}));

const HomeComponent = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const { visitorData } = useSelector((state) => state.memberDetails);
  const [bannerList, setBannerList] = useState([]);
  const [faqList, setFaqList] = useState([]);

  useEffect(() => {
    axios({ url: "/admin/profile/get-event-banner" }).then((response) => {
      if (response.status) {
        setBannerList(
          response.data.length != 0
            ? response.data
            : [
                {
                  fake: true,
                  banner_image:
                    "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/2c3a1f49ab5f419da2b5542744edc32f/1745394946734_20250423_1318_No%20Event%20Live_simple_compose_01jsgsvsk7fczrjkhccsc9r5n2.png",
                },
              ]
        );
      }
    });

    axios({ url: "/event/booking/get-faq" }).then((response) => {
      if (response.status) {
        setFaqList(response.data);
      }
    });
  }, []);

  const categories = [
    {
      name: "Event",
      icon: Events,

      route: pages.eventListPage.route,
      comingSoon: true,
      // comingSoon: bannerList[0]?.fake ? true : false,
    },
    {
      name: "Govt",
      icon: Corporate,

      route: visitorData.ID
        ? pages.AppointmentBooking.route
        : `/appointment/appointment-booking`,
      comingSoon: true,
    },
    {
      name: "Meeting Room",
      icon: Meeting,
      route: pages.MeetingRoomList.route,
      comingSoon: true,
    },
    {
      name: "Hotels",
      icon: Hotels,

      route: pages.HotelBookingPage.route,
      comingSoon: false,
    },
  ];

  return (
    <Fragment>
      <OuterBox>
        <OuterPaper>
          <EventSlider bannerList={bannerList} backgroundColor="#FFF" />
          <Grid item container padding={2.5}>
            <Typography
              variant="h4"
              fontWeight="900"
              align="start"
              gutterBottom
            >
              Browse by Category
            </Typography>
            <CategoryGrid>
              {categories.map((category, index) => (
                <CategoryItem
                  key={index}
                  onClick={() =>
                    !category.comingSoon && navigate(category.route)
                  }
                  style={{ position: "relative" }}
                >
                  <CategoryIcon src={category.icon} />
                  <Typography
                    variant="h6"
                    fontWeight="400"
                    sx={{ margin: "0px 10px" }}
                  >
                    {category.name}
                  </Typography>

                  {category.comingSoon && (
                    <Typography
                      variant="caption"
                      fontWeight="600"
                      sx={{
                        position: "absolute",
                        top: 5,
                        right: 5,
                        background: "#f44336",
                        color: "#fff",
                        borderRadius: "8px",
                        padding: "2px 6px",
                        fontSize: "10px",
                        zIndex: 2,
                      }}
                    >
                      Coming Soon
                    </Typography>
                  )}
                </CategoryItem>
              ))}
            </CategoryGrid>
          </Grid>

          <Grid item container padding={2.5}>
            <Typography
              variant="h4"
              fontWeight="900"
              align="start"
              gutterBottom
            >
              FAQ
            </Typography>

            <Box component="div" class="faq">
              {faqList.map((item, index) => {
                return (
                  <Fragment>
                    <input id="faq-a" type="checkbox"></input>

                    <label
                      for="faq-a"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <div>
                        <p class="faq-heading">
                          {`Q${index + 1} .`} {item.question}
                        </p>
                      </div>

                      <p class="faq-text">{item.answer}</p>
                    </label>
                  </Fragment>
                );
              })}
            </Box>
          </Grid>
        </OuterPaper>
      </OuterBox>
    </Fragment>
  );
};

export default HomeComponent;
